<app-shared-drawer
  [isOpen]="isOpen"
  [title]="flowConfig.title"
  [subtitle]="flowConfig.subtitle"
  className="drawer-langflow-chat"
  (onClose)="close()">

  <div #chatContainer class="langflow-chat-container">
    <div *ngIf="isScriptLoading" class="text-center py-3">
      <span>Carregando assistente...</span>
      <i class="fa fa-spinner fa-spin ml-50"></i>
    </div>

    <langflow-chat
      *ngIf="scriptLoaded && isOpen && chatWidth > 0 && chatHeight > 0"
      start_open="true"
      window_title=""
      chat_trigger_style='{"display":"none"}'
      chat_window_style='{"maxWidth":"100%","margin":"0","boxSizing":"border-box","position":"relative","borderRadius":"0","boxShadow":"none"}'
      [attr.flow_id]="flowConfig.flowId"
      [attr.host_url]="langflowConfig.hostUrl"
      [attr.tweaks]="tweaksJson"
      [attr.width]="chatWidth"
      [attr.height]="chatHeight"
      online_message="Responderemos o mais breve possível"
      placeholder="Digite sua mensagem..."
      placeholder_sending="Enviando..."
      [attr.api_key]="langflowConfig.apiKey">
    </langflow-chat>
  </div>
</app-shared-drawer>
